import { render } from "./detailsboitier.vue?vue&type=template&id=078cf18f&scoped=true"
import script from "./detailsboitier.vue?vue&type=script&lang=js"
export * from "./detailsboitier.vue?vue&type=script&lang=js"

import "./detailsboitier.vue?vue&type=style&index=0&id=078cf18f&scoped=true&lang=css"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078cf18f"]])

export default __exports__